export default {
  benefits: {
    earn_points: 'Ganhe pontos com cada pedido',
    get_deals: 'Receba descontos exclusivos',
    redeem_points: 'Troque pontos por comida grátis',
  },
};
